import { createSelector } from '@reduxjs/toolkit';

export const getNewsGallery = ()=> {
    return createSelector(
        (state) => state.newsgallery,
        (state) => state
    )
}